import React, { useMemo, useState } from 'react';
import styled from 'styled-components';
import { Button, Tooltip } from 'antd';
import { Help } from '@styled-icons/material-twotone';
import theme from '@config/theme';
import MarkdownHelpDrawer from '@shared/ui/Help/MarkdownHelpDrawer';

interface IComponent {
  helpMessage?: string;
  markdownPath?: string; // e.g. "/docs/inventory/importing_inventory.md"
  drawerTitle?: string;
  style?: any;
}

const HelpIcon = styled(Help)<{ showHighlight: boolean }>`
  width: 24px;
  color: ${theme.palette.primary.hue};
  cursor: pointer;
  border-radius: 50%;
  transition: all 0.2s ease;
`;

const HelpButton = ({ helpMessage, markdownPath, drawerTitle, style = {} }:IComponent) => {
  const [isOpen, setIsOpen] = useState(false);

  const tooltipContent = useMemo(() => {
    if (!markdownPath) return helpMessage || '';
    return (
      <div style={{ maxWidth: 360 }}>
        <div style={{ marginBottom: 8 }}>
          {helpMessage || 'See documentation for more details.'}
        </div>
        <Button type="primary" size="small" onClick={() => setIsOpen(true)}>
          See documentation
        </Button>
      </div>
    );
  }, [helpMessage, markdownPath]);

  return (
    <>
      <Tooltip 
        placement="top" 
        title={tooltipContent} 
        getPopupContainer={(triggerNode) => triggerNode.parentElement || document.body}
      >
        <HelpIcon 
          style={style} 
          onClick={() => markdownPath ? setIsOpen(true) : undefined} 
        />
      </Tooltip>
      {markdownPath && (
        <MarkdownHelpDrawer
          isOpen={isOpen}
          onClose={() => setIsOpen(false)}
          markdownPath={markdownPath}
          title={drawerTitle}
        />
      )}
    </>
  );
};

export default HelpButton;
